import PropTypes from 'prop-types'
import {Text, Box} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import MembershipDetails from './MembershipDetails'

const OtherState = ({memberStatus, memberBusinessName, abn}) => {
  const {t} = useTranslation('points')

  return (
    <>
      <Box>
        <Text textStyle="body-intro-medium" mb="md">
          {t('points:qantasConnectionDrawer.otherState.title', {memberStatus})}
        </Text>

        <Text>
          {t('points:qantasConnectionDrawer.otherState.contactMessage', {
            memberStatus,
          })}
        </Text>
      </Box>

      <MembershipDetails memberBusinessName={memberBusinessName} abn={abn} />
    </>
  )
}

OtherState.propTypes = {
  memberStatus: PropTypes.string.isRequired,
  memberBusinessName: PropTypes.string.isRequired,
  abn: PropTypes.string.isRequired,
}

export default OtherState
